/**
 * Created by Claude on 11.06.2026
 */

// eslint-disable-next-line
let SeasonPassQuestCompleteAnimation = {};

SeasonPassQuestCompleteAnimation.show = function (quest) {
    const scene = cleverapps.Scenes.GetRunningScene();

    const animation = Prefab.instantiate(
        bundles.season_pass_quest_complete_animation_prefab.jsons.quest_complete_animation_prefab_json,
        { args: [{ quest }] }
    );

    scene.addChild(animation);

    return animation;
};